'use client';
import * as React from 'react';

export const GridChartsIntegrationContext = React.createContext<unknown>(undefined);
